'use strict';

(function () {
  if (!customElements.get('slideshow-banner')) {
    const BREAKPOINTS = {
      sm: 750,
      lg: 990,
    };

    class SlideshowBanner extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.pagination = this.querySelector('.swiper-pagination');
        this.tabs = this.querySelectorAll('.slideshow-tab');
        this.prevBtn = this.querySelector('.slideshow-tabs__arrow--prev');
        this.nextBtn = this.querySelector('.slideshow-tabs__arrow--next');

        this.initSwiper();
      }

      initSwiper = () => {
        const slides = this.querySelectorAll('.swiper-slide');
        const slidesLength = slides.length;

        let {
          slidesPerView = 1,
          slidesPerViewSm,
          slidesPerViewLg,
          effect,
          speed,
          autoplay,
          loop = 'false',
          spaceBetween,
          spaceBetweenPc
        } = this.dataset;

        if (!slidesPerViewSm) slidesPerViewSm = slidesPerView;
        if (!slidesPerViewLg) slidesPerViewLg = slidesPerView;

        speed = speed * 1000;
        loop = loop == 'false' ? false : true;

        if (autoplay == 'true') {
          autoplay = {
            delay: speed,
            disableOnInteraction: false,
          };
        } else {
          autoplay = false;
        }

        let pagination = false;

        if (this.pagination) {
          pagination = {
            el: this.pagination,
            clickable: true,
            type: 'bullets',
          };
        }

        const swiperParams = {
          autoplay,
          slidesPerView,
          pagination,
          grabCursor: true,
          effect,
          centeredSlides: true,
          loop,
          spaceBetween,
          breakpoints: {
            [BREAKPOINTS.sm]: {
              slidesPerView: slidesPerViewSm,
              spaceBetween: spaceBetweenPc,
            },
            [BREAKPOINTS.lg]: {
              slidesPerView: slidesPerViewLg,
              spaceBetween: spaceBetweenPc,
            },
          },

          on: {
            init: () => this.updateTabs(),
            slideChange: () => this.updateTabs(),
          }
        };

        this.swiper = new Swiper(this, swiperParams);
        const tabs = this.querySelectorAll('.slideshow-tab');
const duration = speed; // same as swiper autoplay delay

const resetTabs = () => {
  tabs.forEach(tab => {
    tab.classList.remove('slideshow-tab--active');

    const fill = tab.querySelector('.slideshow-tab__bar-fill');
    if (fill) {
      fill.style.animation = 'none';
      fill.offsetHeight; // force reflow
      fill.style.animation = null;
    }
  });
};

const activateTab = (index) => {
  resetTabs();

  const activeTab = tabs[index];
  if (!activeTab) return;

  activeTab.classList.add('slideshow-tab--active');

  const fill = activeTab.querySelector('.slideshow-tab__bar-fill');
  if (fill) {
    fill.style.animationDuration = `${duration}ms`;
  }
};

activateTab(0);

this.swiper.on('slideChange', () => {
  activateTab(this.swiper.realIndex);
});

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.swiper.slideToLoop(index);
          });
        });

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.swiper.slidePrev();
          });
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.swiper.slideNext();
          });
        }
      };

      updateTabs() {
        if (!this.tabs) return;

        this.tabs.forEach(tab => {
          tab.classList.remove('slideshow-tab--active');
        });

        const active = this.swiper.realIndex;

        if (this.tabs[active]) {
          this.tabs[active].classList.add('slideshow-tab--active');
        }
      }
    }

    customElements.define('slideshow-banner', SlideshowBanner);
  }
})();